import { useEffect, useState } from 'react'
import { i18n } from '@fs/zion-locale'
import getPersonIds from '../usePedigree/personIdsUtils'
import { getPortraits } from '../../services'
import { useErrorOverlay } from '../useDataStatusOverlay/useDataStatusOverlay'

export const COMPLETE = {
  FAIL: 'fail',
  SUCCESS: 'success',
}

// Retrieve portrait objects for each person in a pedigree
// if they have a portrait.
export function usePortraits(pedigree) {
  const [portraits, setPortraits] = useState({})
  const [personIds, setPersonIds] = useState([])
  const showError = useErrorOverlay()
  useEffect(() => {
    const setPersonIdsAsync = async () => {
      setPersonIds(await getPersonIds(pedigree))
    }
    setPersonIdsAsync()
  }, [pedigree])

  useEffect(() => {
    let canceled = false
    if (!canceled && personIds?.length) {
      getPortraits(personIds)
        .then((portraitResults) => {
          if (!canceled) {
            setPortraits({ ...portraitResults, complete: COMPLETE.SUCCESS })
          }
        })
        .catch((e) => {
          setPortraits({ complete: COMPLETE.FAIL })
          showError(i18n.t('errors.getPortraits', 'An error occurred loading images.'), e)
        })
    }
    return () => {
      canceled = true
    }
  }, [personIds, showError])

  return portraits
}

export default usePortraits
